import { memo } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { getLocationFor } from '@trinity/chat-components';
import { Chip } from '@trinity/chat-components/components/presentation/Chip.js';

type Props = {
  className?: string;
};

export const WorkspacesNavMenu = memo(({ className }: Props) => {

  return (
    <Root className={className}>
      <Label>Workspaces:</Label>
      <Link to={getLocationFor.workspaces.root({ workspace: 'personal' })}>
        <ChipStyled>Personal</ChipStyled>
      </Link>
      <Link to={getLocationFor.workspaces.root({ workspace: 'group' })}>
        <ChipStyled>Account</ChipStyled>
      </Link>
      <Link to={getLocationFor.workspaces.root({ workspace: 'shared' })}>
        <ChipStyled>Shared</ChipStyled>
      </Link>
    </Root>
  );
});

const Label = styled.div({
  fontFamily: 'var(--font-semibold)',
  fontSize: 18,
  marginRight: 10,
});

const Root = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

const ChipStyled = styled(Chip)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 60,
}));
